import React from "react";
import { useTranslation } from "react-i18next";
import { gql } from "@apollo/client";
import DeviceStatisticTemplate from "./DeviceStatisticTemplate";
import { formatToLocalTime } from "../utils/dateUtils";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const PAGINATE_AKIFERRA_STAT = gql`
    query PaginateAkiferraTelemetry($pagination: Pagination!, $sortBy: [SortBy!], $criteria: DeviceAkiferraTelemetryCriteria) {
        paginateDeviceAkiferraTelemetry(pagination: $pagination, sortBy: $sortBy, criteria: $criteria) {
            pageInfo {
                totalElements
                totalPages
                numberOfElements
                pageNumber
                pageSize
            }
            content {
                id
                device
                serialNumber
                location
                locationName
                customer
                customerName
                reseller
                resellerName
                workingMode
                waterType
                outputSide
                targetFlowInMilliliters
                flowInMilliliters
                conductivity
                waterTemperature
                small
                shutoffType
                conductivityWarningExist
                conductivityShutdownExist
                timestamp
                updatedTimestamp
                deleted
            }
        }
    }
`;

export default function AkiferraTelemetry() {
    const { t } = useTranslation();
    const redColor = "#ff0000";
    const columns = [
        { field: "serialNumber", label: t("devicePageAkiferra.columns.serial"), sortable: true },
        { field: "resellerName", label: t("devicePageAkiferra.columns.reseller"), sortable: true },
        { field: "customerName", label: t("devicePageAkiferra.columns.customer"), sortable: true },
        { field: "locationName", label: t("devicePageAkiferra.columns.location"), sortable: true },
        { field: "workingMode", label: t("devicePageAkiferra.columns.workingMode"), format: (v) => (v ? t(`devicePageAkiferra.workingMode.${v}`) : "-") },
        { field: "waterType", label: t("devicePageAkiferra.columns.waterType"), format: (v) => (v ? t(`devicePageAkiferra.waterType.${v}`) : "-") },
        { field: "outputSide", label: t("devicePageAkiferra.columns.outputSide"), format: (v) => (v ? t(`devicePageAkiferra.outputSide.${v}`) : "-") },
        { field: "targetFlowInMilliliters", label: t("devicePageAkiferra.columns.targetFlow") },
        { field: "flowInMilliliters", label: t("devicePageAkiferra.columns.flow") },
        { field: "conductivity", label: t("devicePageAkiferra.columns.conductivity") },
        { field: "waterTemperature", label: t("devicePageAkiferra.columns.waterTemperature"), format: (v) => Number.isFinite(v) ? Math.round(v) : (v ?? "-") },
        { field: "small", label: t("devicePageAkiferra.columns.small"), format: (v) => v ? t("devicePageAkiferra.columns.smallPortion") : t("devicePageAkiferra.columns.largePortion") },
        { field: "shutoffType", label: t("devicePageAkiferra.columns.shutoffType"), format: (v) => (v ? t(`devicePageAkiferra.shutoffType.${v}`) : "-") },
        {
            field: "conductivityWarningExist", label: t("devicePageAkiferra.columns.warningExist"), format: (v) =>
                v ? <span style={{ color: redColor }}>{t("devicePageAkiferra.columns.yes")}</span> : t("devicePageAkiferra.columns.no")
        },
        { field: "conductivityShutdownExist", label: t("devicePageAkiferra.columns.shutdownExist"), format: (v) =>
                v ? <span style={{ color: redColor }}>{t("devicePageAkiferra.columns.yes")}</span> : t("devicePageAkiferra.columns.no")},
        {
            field: "timestamp",
            label: t("devicePageAkiferra.columns.timestamp"),
            sortable: true,
            format: (v) => (v ? formatToLocalTime(v) : "-"),
            nowrap: true,
            sticky: "right",
            width: 180,
        }
    ];

    return (
        <DeviceStatisticTemplate
            title={t("akiferraTelemetry.title")}
            subtitle={t("akiferraTelemetry.subtitle")}
            query={PAGINATE_AKIFERRA_STAT}
            columns={columns}
            icon={<FilterAltIcon />}
        />
    );
}
